import { IApplicationState } from '../../types/redux';
import { getAeroPhotoTourLink } from '../newbuilding/getAeroPhotoTourLink';

export const getIsAeroPhotoTourAvailable = (state: IApplicationState) => {
  const link = getAeroPhotoTourLink(state);

  return Boolean(link);
};
